var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-loading",style:({
    backgroundColor: _vm.backgroundColor,
  })},[_c('img',{staticClass:"logo",attrs:{"src":"images/logo.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }